import { forwardRef } from "react";
import { Toast, ToastProps } from "primereact/toast";

const MobileToast = forwardRef<Toast, ToastProps>(({ className, ...props }, ref) => (
    <Toast
        ref={ref}
        {...props}
        position="bottom-right"
        className={`mobile-toast ${className ?? ""}`.trim()}
    />
));

MobileToast.displayName = "MobileToast";

export default MobileToast;
